import { gql } from '@apollo/client';

export const GET_ACTIVE_UNIQUE_PROFILE_METRICS = gql(/* GraphQL */ `
  query GetActiveUniqueProfilesMetrics($filters: MetricCaptureRateFilter!) {
    getActiveUniqueProfileMetrics(filters: $filters) {
      totalProfiles
    }
  }
`);

export const GET_EMAIL_CAPTURE_RATE = gql(/* GraphQL */ `
  query GetEmailCaptureRate($filters: MetricCaptureRateFilter!) {
    getEmailCaptureRate(filters: $filters) {
      emailCaptureRate
    }
  }
`);
